<script setup lang="ts">
import PdsAvatar from '@/components/pds/PdsAvatar.vue';
import PdsButton from '@/components/pds/PdsButton.vue';
import { useAuthStore } from '@/stores/auth/auth.slice';
import { computed } from 'vue';
import DevicesCard from '../components/DevicesCard.vue';
import LabeledPanel from '../components/LabeledPanel.vue';
import PageBar from '../components/PageBar.vue';
import { useOperator } from '../composables/useOperator';

const authStore = useAuthStore();
const { name, initials, role, store, storeLine } = useOperator();

const rows = computed(() => [
  { label: 'Commerce', value: storeLine.value || '—' },
  { label: 'Langue', value: 'Français (Belgique)' },
]);
</script>

<template>
  <PageBar tall>
    <h1 class="text-[24px] leading-[1.15] font-bold tracking-[-0.2px]">
      Réglages
    </h1>
    <template #aside>
      <PdsButton variant="second" size="md" fit to="/reglages/imprimante">
        Configurer l’imprimante
      </PdsButton>
    </template>
  </PageBar>

  <main
    class="no-scrollbar grid min-h-0 flex-1 grid-cols-1 gap-5 overflow-y-auto px-4 pt-5 pb-4 sm:px-5 sm:pb-5 lg:grid-cols-[380px_1fr] lg:overflow-hidden"
  >
    <LabeledPanel label="Compte">
      <div class="flex items-center gap-[14px] pb-5">
        <PdsAvatar :initials="initials" size="md" />
        <div class="min-w-0">
          <p class="text-[14px] leading-[1.4] font-semibold">{{ name }}</p>
          <p class="text-encre-douce truncate text-[12px] leading-[1.45]">
            {{ [role, store].filter(Boolean).join(' · ') }}
          </p>
        </div>
      </div>
      <dl class="flex flex-col">
        <div
          v-for="row in rows"
          :key="row.label"
          class="border-filet flex items-center gap-[14px] border-t pt-[15px] pb-4 text-[12px] leading-[1.45]"
        >
          <dt class="text-encre-douce min-w-[90px]">{{ row.label }}</dt>
          <dd class="font-semibold">{{ row.value }}</dd>
        </div>
      </dl>
      <PdsButton variant="second" class="mt-auto" @click="authStore.logout()">
        Se déconnecter
      </PdsButton>
    </LabeledPanel>
    <DevicesCard />
  </main>
</template>
